/**
 * Autorizacion por rol global del SSO.
 *
 * Esto es solo la capa visual: la API vuelve a validar cada rol en el guard.
 * Ocultar un boton no es una medida de seguridad.
 */

import type { ReactNode } from 'react';
import { useAuthContext } from '@presentation/context/AuthContext';

interface RequireRoleProps {
  roles: string[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function RequireRole({ roles, children, fallback = null }: RequireRoleProps) {
  const { hasRole } = useAuthContext();

  if (!hasRole(...roles)) return <>{fallback}</>;

  return <>{children}</>;
}
